import React, { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/pro-solid-svg-icons';

import Modal from 'bundles/apex/playbooks/config/tasks/copy_modal';

export default function CopyTask() {
  const [showModal, setShowModal] = useState();

  return <>
    <a className="ms-4 text-primary clickable" onClick={() => setShowModal(true)}>
      <FontAwesomeIcon className="me-2" icon={faCopy} />
      Copy Tasks
    </a>

    <Modal
      show={showModal}
      onHide={() => setShowModal(false)}
    />
  </>;
}
